import { render, staticRenderFns } from "./images-tab.vue?vue&type=template&id=c6bc27c8&scoped=true"
import script from "./images-tab.vue?vue&type=script&lang=js"
export * from "./images-tab.vue?vue&type=script&lang=js"
import style0 from "./images-tab.vue?vue&type=style&index=0&id=c6bc27c8&prod&scoped=true&lang=css"
import style1 from "./images-tab.vue?vue&type=style&index=1&id=c6bc27c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bc27c8",
  null
  
)

export default component.exports